import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Input, Button, Card, Typography, Alert, Space } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useUserContext } from '../../../Contexts/user';
import { login } from '../../../API/auth';
import logo from '../../../assets/Icons/logo.png';

const { Title } = Typography;

function Login() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { setUserData } = useUserContext();
  const navigate = useNavigate();

  const handleSubmit = async (values) => {
    setLoading(true);
    setError(null);
    try {
      const res = await login({ email: values.username, password: values.password });

      if (res?.status !== 200) {
        throw new Error(res?.data?.error || 'Login failed. Please check your credentials.');
      }

      // MFA is enabled for this user — redirect to MFA verification step
      if (res?.data?.mfa_required) {
        sessionStorage.setItem('mfa_token', res.data.mfa_token);
        navigate('/mfa-verify');
        return;
      }

      // Normal login — no MFA
      setUserData(res?.data?.user);
      localStorage.setItem('token', res?.data?.token);
      localStorage.setItem('user', JSON.stringify(res?.data?.user));
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: '#f0f2f5',
      }}
    >
      <Card style={{ width: 400, boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <div style={{ textAlign: 'center' }}>
            <img src={logo} alt="Arett Logo" style={{ width: 80 }} />
            <Title level={2}>Arett Contract Portal</Title>
            <Typography.Text type="secondary">Sign in to continue</Typography.Text>
          </div>

          <div style={{ textAlign: 'center' }}>
            <Typography.Text type="secondary">
              Don't have an account?{' '}
              <a
                href="https://forms.office.com/Pages/ResponsePage.aspx?id=Umepd_yvm0WChE0LfWnRctvZ6x-T2kJHhOHU3IVYOABUNkRaNEJYSktKUkxDRjBaMEJIMEw3OU02Sy4u"
                target="_blank"
                rel="noopener noreferrer"
              >
                Request Access
              </a>
            </Typography.Text>
          </div>

          {error && (
            <Alert message={error} type="error" showIcon closable onClose={() => setError(null)} />
          )}

          <Form name="login" onFinish={handleSubmit} layout="vertical" size="large">
            <Form.Item
              name="username"
              rules={[{ required: true, message: 'Please enter your username' }]}
            >
              <Input prefix={<UserOutlined />} placeholder="Username" autoComplete="username" />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[{ required: true, message: 'Please enter your password' }]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="Password"
                autoComplete="current-password"
              />
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" loading={loading} block>
                Sign In
              </Button>
            </Form.Item>
          </Form>
        </Space>
      </Card>
    </div>
  );
}

export default Login;
